import React, { useState } from "react";
import CircleButton from "../CircleButton";
import { MdArrowUpward } from "react-icons/md";
import Container from './styles';

const BackToTop = ({}) => {

    const [showButton, setShowButton] = useState(false);

    const goBackToTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const checkScroll = () => {
        if (!showButton && window.pageYOffset > 400){
            setShowButton(true)
        } else if (showButton && window.pageYOffset <= 400){
            setShowButton(false)
        }
    };

    window.addEventListener('scroll', checkScroll);

    return showButton && (
        <Container>
            <span>voltar ao topo</span>
            <CircleButton onClick={goBackToTop}>
                <MdArrowUpward />
            </CircleButton>
        </Container>
    )
}

export default BackToTop;
